export default "__VITE_ASSET__DEM4wCH3__"